import {
  today,
  last2,
  last60,
  last7,
  last30,
  firstDateOfMonth,
  kompackDate,
} from '@/store/helpers'
import { LABELDAY, LABELMONTH } from '@/libs/formatDate'

export const coloumnTableList = [
  {
    key: 'cnote',
    label: 'No. Resi',
    class: 'p-1 align-middle',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
    },
    tdClass: 'text-black',
  },
  {
    key: 'created_at',
    label: 'Tanggal',
    class: 'p-1 align-middle',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
    },
    tdClass: 'text-black',
  },
  {
    key: 'shipping',
    label: 'Ekspedisi',
    class: 'p-1 align-middle text-center',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
    },
    tdClass: 'text-black',
  },
  {
    key: 'claim_type',
    label: 'Jenis Claim',
    class: 'p-1 align-middle',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
    },
    tdClass: 'text-black',
  },
  {
    key: 'nominal',
    label: 'Nilai Nominal',
    class: 'p-1 align-middle text-center',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
    },
    tdClass: 'text-black',
  },
  {
    key: 'claim_proof',
    label: 'Bukti',
    class: 'p-1 align-middle text-center',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
    },
    tdClass: 'text-black',
  },
  {
    key: 'order_id',
    label: 'History Diskusi',
    class: 'p-1 align-middle text-center',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
    },
    tdClass: 'text-black',
  },
  {
    key: 'status_claim',
    label: 'Status Pengajuan',
    class: 'p-1 align-middle text-center',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
    },
    tdClass: 'text-black',
  },
]

export const listStatusType = [
  { id: '', label: 'Semua' },
  { id: 'retur', label: 'Claim Paket Retur' },
  { id: 'hilang', label: 'Claim Paket Hilang' },
  { id: 'rusak', label: 'Delivered - Paket Rusak' },
  { id: 'tidak_diterima', label: 'Delivered - Paket Tidak Diterima' },
  { id: 'rts_rusak', label: 'RTS - Paket Rusak' },
  { id: 'rts_tidak_diterima', label: 'RTS - Paket Tidak Diterima' },
  { id: 'paksa_rts', label: 'Laporan - Paket Retur Diterima (RTS)' },
  { id: 'paksa_diterima', label: 'Laporan - Paket Diterima (Delivered)' },
]

export const listStatusClaims = [
  { id: '', label: 'Semua', value: '' },
  { id: 0, label: 'Direview', value: 'Nunggu Review' },
  { id: 1, label: 'Disetujui', value: 'Disetujui' },
  { id: 2, label: 'Ditolak', value: 'Ditolak' },
]

export const filterDate = {
  ranges: {
    'Semua ': [kompackDate, today],
    '7 Hari Terakhir': [last7, today],
    '30 Hari Terakhir': [last30, today],
    'Bulan Ini': [firstDateOfMonth, today],
  },
  locale: {
    format: 'dd/mm/yyyy',
    daysOfWeek: ['Min', 'Sen', 'Sel', 'Rab', 'Kam', 'Jum', 'Sab'],
    monthNames: [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'Mei',
      'Jun',
      'Jul',
      'Agu',
      'Sep',
      'Okt',
      'Nov',
      'Des',
    ],
  },
}

export const listprooveItem = {
  cnote: '',
  video: '',
  images: [],
  type: '',
  imagePreviewProof: '',
}

export const rangeDate = {
  startDate: today,
  endDate: today,
}
export const locale = {
  applyLabel: 'Pilih',
  cancelLabel: 'Batal',
  format: 'dd/mm/yyyy',
  daysOfWeek: LABELDAY,
  monthNames: LABELMONTH,
}
export const ranges = {
  'Hari Ini': [today, today],
  Kemarin: [last2, last2],
  'Bulan Ini': [firstDateOfMonth, today],
  'Custom Range': [last60, today],
}
